'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationLinkedFbcService = function ConfigurationLinkedFbcService(fileSaveService, momentService, configurationService, restangular, $q, $http) {
  var updateBulkLinkedFbcService = restangular.service('external').one('faresoptimizer').one('linkedfbc').one('bulk');
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Category', 'Cabin', 'Origin Country', 'Destination Country', 'Sponsor Carrier', 'Sponsor Origin', 'Sponsor Destination', 'Sponsor Fare Type Indicator', 'Sponsor Fare Brand', 'Sponsor FBC', 'Target Carrier', 'Target Origin', 'Target Destination', 'Target Fare Type Indicator', 'Target Fare Brand', 'Target FBC', 'Value', '% Indicator']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([row.category, _.isNil(row.linkedCabin) ? '' : row.linkedCabin.toUpperCase(), _.isNil(row.foOriginCountry) ? '' : row.foOriginCountry.toUpperCase(), _.isNil(row.foDestCountry) ? '' : row.foDestCountry.toUpperCase(), _.isNil(row.foSponsorCarrier) ? '' : row.foSponsorCarrier.toUpperCase(), _.isNil(row.foSponsorOrigin) ? '' : row.foSponsorOrigin.toUpperCase(), _.isNil(row.foSponsorDestination) ? '' : row.foSponsorDestination.toUpperCase(), _.isNil(row.sponsorFareTypeIndicator) ? '' : row.sponsorFareTypeIndicator.toUpperCase(), _.isNil(row.sponsorFareBrand) ? '' : row.sponsorFareBrand.toUpperCase(), _.isNil(row.sponsorFareBasisCode) ? '' : row.sponsorFareBasisCode.toUpperCase(), _.isNil(row.foTargetCarrier) ? '' : row.foTargetCarrier.toUpperCase(), _.isNil(row.foTargetOrigin) ? '' : row.foTargetOrigin.toUpperCase(), _.isNil(row.foTargetDestination) ? '' : row.foTargetDestination.toUpperCase(), _.isNil(row.targetFareTypeIndicator) ? '' : row.targetFareTypeIndicator.toUpperCase(), _.isNil(row.targetFareBrand) ? '' : row.targetFareBrand.toUpperCase(), _.isNil(row.targetFareBasisCode) ? '' : row.targetFareBasisCode.toUpperCase(), row.value, row.percentageIndicator]);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FOLinkedFares.csv');
  }
  function deleteFromServer(payloads) {
    return _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/faresoptimizer/linkedfbc',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
  }
  function remove(rows) {
    var payloads = buildRemovePayloads(rows);
    return $q.all(deleteFromServer(payloads));
  }
  function saveToServer(payloads) {
    return updateBulkLinkedFbcService.customPUT({
      value: payloads
    });
  }
  function validate(editedRows, gridData) {
    var filteredData = _.reject(gridData, {
      'isNewlyAdded': true
    });
    return areRowsValid(editedRows, filteredData);
  }
  function validateField(rowProperty, field, valid) {
    if (valid && _.isNil(rowProperty)) {
      toastr.error(field + ' must not be empty');
      valid = false;
    }
    return valid;
  }
  function sponsorAndTargetMarketsBelongToSamePos(airportRegionByCityCode, editedRow, valid) {
    if (valid) {
      var sponsorAirportRegion = airportRegionByCityCode[editedRow.sponsorOrigin];
      var targetAirportRegion = airportRegionByCityCode[editedRow.targetOrigin];
      if (!_.isNil(sponsorAirportRegion) && !_.isNil(targetAirportRegion) && sponsorAirportRegion[0].pos !== targetAirportRegion[0].pos) {
        toastr.error('Sponsor and target markets belong to different POS');
        valid = false;
      }
    }
    return valid;
  }
  function isValidFareBrandAndValue(fareBrandMap, editedRow, gridData, valid) {
    if (valid) {
      for (var i = 0, gridDataLength = gridData.length; i < gridDataLength; i++) {
        if (duplicateRowWithMarketAndCategoryIdentified(gridData[i], editedRow)) {
          if (!isNullOrEmpty(gridData[i].targetFareBrand) && !_.isNil(fareBrandMap[editedRow.targetFareBrand]) && fareBrandMap[editedRow.targetFareBrand][0].fareBrandIndex < fareBrandMap[gridData[i].targetFareBrand][0].fareBrandIndex && editedRow.value < gridData[i].value && editedRow.percentageIndicator === gridData[i].percentageIndicator) {
            toastr.error(' Fare Brand ' + editedRow.targetFareBrand + ' with greater hierarchy has lesser value than ' + gridData[i].targetFareBrand);
            valid = false;
          }
          if (!isNullOrEmpty(gridData[i].targetFareBrand) && !_.isNil(fareBrandMap[editedRow.targetFareBrand]) && fareBrandMap[editedRow.targetFareBrand][0].fareBrandIndex > fareBrandMap[gridData[i].targetFareBrand][0].fareBrandIndex && editedRow.value > gridData[i].value && editedRow.percentageIndicator === gridData[i].percentageIndicator) {
            toastr.error(' Fare Brand ' + editedRow.targetFareBrand + ' with lesser hierarchy has greater value than ' + gridData[i].targetFareBrand);
            valid = false;
          }
        }
      }
    }
    return valid;
  }
  function isNullOrEmpty(field) {
    return _.isNil(field) || field === '';
  }
  function validateFields(editedRow, valid) {
    if (valid) {
      if (isNullOrEmpty(editedRow.originCountry) && isNullOrEmpty(editedRow.sponsorOrigin)) {
        toastr.error('One of country definition or market definition must be present');
        valid = false;
      }
      if (valid && (!isNullOrEmpty(editedRow.originCountry) || !isNullOrEmpty(editedRow.destinationCountry)) && (!isNullOrEmpty(editedRow.sponsorOrigin) || !isNullOrEmpty(editedRow.targetOrigin) || !isNullOrEmpty(editedRow.sponsorDestination) || !isNullOrEmpty(editedRow.targetDestination))) {
        toastr.error('Only one of country definition or market definition must be defined');
        valid = false;
      }
      if (valid && (isNullOrEmpty(editedRow.sponsorCarrier) || isNullOrEmpty(editedRow.targetCarrier))) {
        toastr.error('Both Sponsor and Target Carrier must be defined');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.sponsorOrigin) && !isNullOrEmpty(editedRow.targetOrigin) || !isNullOrEmpty(editedRow.sponsorOrigin) && isNullOrEmpty(editedRow.targetOrigin)) {
        toastr.error('Both Sponsor and Target market definition must be defined');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.sponsorOrigin) && !isNullOrEmpty(editedRow.sponsorDestination)) {
        toastr.error('Sponsor Origin must be present');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.sponsorOrigin) && isNullOrEmpty(editedRow.sponsorDestination)) {
        toastr.error('Sponsor Destination must be present');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.targetOrigin) && !_.isNil(editedRow.targetDestination) && editedRow.targetDestination !== '') {
        toastr.error('Target Origin must be present');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.targetOrigin) && isNullOrEmpty(editedRow.targetDestination)) {
        toastr.error('Target Destination must be present');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.originCountry) && !isNullOrEmpty(editedRow.destinationCountry)) {
        toastr.error('Origin Country must be present');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.originCountry) && isNullOrEmpty(editedRow.destinationCountry)) {
        toastr.error('Destination Country must be present');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.sponsorFareBasisCode) && !isNullOrEmpty(editedRow.sponsorFareBrand)) {
        toastr.error('Only one of Sponsor FBC or Sponsor Fare Brand must be defined');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.targetFareBasisCode) && !isNullOrEmpty(editedRow.targetFareBrand)) {
        toastr.error('Only one of Target FBC or Target Fare Brand must be defined');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.sponsorFareBrand) && !isNullOrEmpty(editedRow.targetFareBrand)) {
        toastr.error('Sponsor Fare Brand must be defined');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.sponsorFareBrand) && isNullOrEmpty(editedRow.targetFareBrand)) {
        toastr.error('Target Fare Brand must be defined');
        valid = false;
      }
      if (valid && isNullOrEmpty(editedRow.sponsorFareBasisCode) && !isNullOrEmpty(editedRow.targetFareBasisCode)) {
        toastr.error('Sponsor FBC must be defined');
        valid = false;
      }
      if (valid && !isNullOrEmpty(editedRow.sponsorFareBasisCode) && isNullOrEmpty(editedRow.targetFareBasisCode)) {
        toastr.error('Target FBC must be defined');
        valid = false;
      }
      var isSameSponsorAndTargetMarket = isSponsorAndTargetMarketSame(editedRow);
      var isCountriesDefined = isOriginAndDestinationCountriesDefined(editedRow);
      if (valid && (isSameSponsorAndTargetMarket || isCountriesDefined) && !isNullOrEmpty(editedRow.sponsorFareBasisCode) && !isNullOrEmpty(editedRow.targetFareBasisCode) && isSameSponsorAndTargetFbc(editedRow)) {
        toastr.error('Sponsor and target FBC should be different for the same market');
        valid = false;
      }
      if (editedRow.category === 'STRUCTURAL') {
        valid = valid && areFareTypeAndFbcNotDefinedTogether(editedRow);
        if (valid && isNullOrEmpty(editedRow.sponsorFareBasisCode) && isNullOrEmpty(editedRow.sponsorFareBrand)) {
          toastr.error('For STRUCTURAL category sponsor FBC or sponsor fare brand is mandatory');
          valid = false;
        }
        if (valid && isNullOrEmpty(editedRow.targetFareBasisCode) && isNullOrEmpty(editedRow.targetFareBrand)) {
          toastr.error('For STRUCTURAL category target FBC or target fare brand is mandatory');
          valid = false;
        }
      } else {
        if (valid && isSameSponsorAndTargetMarket && isNullOrEmpty(editedRow.sponsorFareBrand) && isNullOrEmpty(editedRow.targetFareBrand) && isNullOrEmpty(editedRow.sponsorFareBasisCode) && isNullOrEmpty(editedRow.targetFareBasisCode)) {
          toastr.error('For TACTICAL category if the markets are same then Sponsor FBC or sponsor fare brand is mandatory');
          valid = false;
        }
        if (valid && !isNullOrEmpty(editedRow.originCountry) && isNullOrEmpty(editedRow.sponsorFareBrand) && isNullOrEmpty(editedRow.targetFareBrand) && isNullOrEmpty(editedRow.sponsorFareBasisCode) && isNullOrEmpty(editedRow.targetFareBasisCode)) {
          toastr.error('For TACTICAL category FBC or fare brands must be defined along with Country definition');
          valid = false;
        }
        if (valid && (!isNullOrEmpty(editedRow.sponsorFareBasisCode) || !isNullOrEmpty(editedRow.targetFareBasisCode)) && (isNullOrEmpty(editedRow.sponsorFareTypeIndicator) || isNullOrEmpty(editedRow.targetFareTypeIndicator))) {
          toastr.error('For TACTICAL category if FBC is present, then Sponsor and Target Fare Type Indicators is mandatory');
          valid = false;
        }
        if (valid && !isNullOrEmpty(editedRow.sponsorFareBrand) && !isNullOrEmpty(editedRow.targetFareBrand) && !isNullOrEmpty(editedRow.sponsorFareTypeIndicator) && !isNullOrEmpty(editedRow.targetFareTypeIndicator) && editedRow.sponsorFareTypeIndicator !== editedRow.targetFareTypeIndicator) {
          toastr.error('For TACTICAL category if fare brands is present, then Sponsor and Target Fare Type Indicators must be same');
          valid = false;
        }
      }
    }
    return valid;
  }
  function hasSameTargetFbcPattern(existingGridRow, filteredEditedRow) {
    if (isNullOrEmpty(existingGridRow.sponsorFareBasisCode) || isNullOrEmpty(existingGridRow.targetFareBasisCode) || isNullOrEmpty(filteredEditedRow.sponsorFareBasisCode) || isNullOrEmpty(filteredEditedRow.targetFareBasisCode)) {
      return false;
    }
    var pickKeys = ['category', 'originCountry', 'destinationCountry', 'sponsorCarrier', 'sponsorOrigin', 'sponsorDestination', 'targetCarrier', 'targetOrigin', 'targetDestination'];
    var comparisonRow = _.pick(existingGridRow, pickKeys);
    var editedRow = _.pick(filteredEditedRow, pickKeys);
    if (_.isEqual(_.pickBy(comparisonRow), _.pickBy(editedRow))) {
      return getPatternConvertedFbc(existingGridRow) === getPatternConvertedFbc(filteredEditedRow);
    }
    return false;
  }
  function getPatternConvertedFbc(rowData) {
    var sponsorFBC = rowData.sponsorFareBasisCode.toLowerCase();
    var targetFBC = rowData.targetFareBasisCode.toLowerCase();
    return convertTargetPatternAsPerSponsor(sponsorFBC, targetFBC);
  }
  function convertTargetPatternAsPerSponsor(sponsorFBC, targetFBC) {
    var targetFbcLength = targetFBC.length;
    var fbcString = '';
    for (var i = 0; i < targetFbcLength; i++) {
      fbcString += targetFBC[i] === '$' ? sponsorFBC[targetFBC[++i] - 1] : targetFBC[i];
    }
    return fbcString;
  }
  function isOriginAndDestinationCountriesDefined(editedRow) {
    return editedRow.sponsorCarrier === editedRow.targetCarrier && !isNullOrEmpty(editedRow.originCountry) && !isNullOrEmpty(editedRow.destinationCountry);
  }
  function isSameSponsorAndTargetFbc(editedRow) {
    var sponsorFBC = editedRow.sponsorFareBasisCode.toLowerCase();
    var targetFBC = editedRow.targetFareBasisCode.toLowerCase();
    if (sponsorFBC === targetFBC) {
      return true;
    }
    var isSame = true;
    var sponsorFbcLength = sponsorFBC.length;
    var targetFbcLength = targetFBC.replace(/\$/g, '').length;
    if (sponsorFbcLength === targetFbcLength) {
      for (var s = 0, t = 0; isSame && s < sponsorFbcLength; s++, t++) {
        if (targetFBC[t] === '$') {
          ++t; // jump an index for 'targetFBC' to get the integer and subtract '1' from the value to get actual position
          var index = parseInt(targetFBC[t], 10) - 1;
          isSame = sponsorFBC[s] === '*' && s === index || sponsorFBC[s] !== '*' && sponsorFBC[s] === sponsorFBC[index];
        } else if (sponsorFBC[s] !== '*') {
          isSame = sponsorFBC[s] === targetFBC[t];
        }
      }
    } else {
      isSame = false;
    }
    return isSame;
  }
  function isTargetDataMatch(editedRow, existingGridRow) {
    var editedRowFormattedTargetFareBasisCode = convertTargetPatternAsPerSponsor(editedRow.sponsorFareBasisCode, editedRow.targetFareBasisCode);
    var existingGridRowFormattedTargetFareBasisCode = convertTargetPatternAsPerSponsor(existingGridRow.sponsorFareBasisCode, existingGridRow.targetFareBasisCode);
    if (isNotSameRow(editedRow, existingGridRow) && !isNullOrEmpty(editedRow.targetFareBrand) && !isNullOrEmpty(existingGridRow.targetFareBrand) && !isNullOrEmpty(editedRow.targetCarrier) && !isNullOrEmpty(existingGridRow.targetCarrier) && !isNullOrEmpty(editedRow.targetOrigin) && !isNullOrEmpty(existingGridRow.targetOrigin) && !isNullOrEmpty(editedRow.targetDestination) && !isNullOrEmpty(existingGridRow.targetDestination)) {
      if (!_.isEqual(_.pickBy(editedRow), _.pickBy(existingGridRow)) && editedRow.category === existingGridRow.category && editedRow.targetOrigin === existingGridRow.targetOrigin && editedRow.targetCarrier === existingGridRow.targetCarrier && editedRow.targetDestination === existingGridRow.targetDestination && editedRow.cabin === existingGridRow.cabin && editedRow.targetFareTypeIndicator === existingGridRow.targetFareTypeIndicator && editedRow.targetFareBrand === existingGridRow.targetFareBrand) {
        toastr.error('Multiple Sponsors defined for same target market, fare brand and fare type indicator');
        return true;
      }
      return false;
    }
    if (editedRow.category === 'STRUCTURAL') {
      if (isNotSameRow(editedRow, existingGridRow) && !isNullOrEmpty(editedRowFormattedTargetFareBasisCode) && !isNullOrEmpty(existingGridRowFormattedTargetFareBasisCode) && !isNullOrEmpty(editedRow.targetCarrier) && !isNullOrEmpty(existingGridRow.targetCarrier) && !isNullOrEmpty(editedRow.targetOrigin) && !isNullOrEmpty(existingGridRow.targetOrigin) && !isNullOrEmpty(editedRow.targetDestination) && !isNullOrEmpty(existingGridRow.targetDestination)) {
        if (!_.isEqual(_.pickBy(editedRow), _.pickBy(existingGridRow)) && editedRow.category === existingGridRow.category && editedRow.targetCarrier === existingGridRow.targetCarrier && editedRow.targetOrigin === existingGridRow.targetOrigin && editedRow.targetDestination === existingGridRow.targetDestination && editedRow.cabin === existingGridRow.cabin && editedRow.targetFareTypeIndicator === existingGridRow.targetFareTypeIndicator && editedRowFormattedTargetFareBasisCode === existingGridRowFormattedTargetFareBasisCode) {
          toastr.error('Multiple Sponsors defined for same target market-fbc and fare type indicator');
          return true;
        }
      }
    } else {
      if (isNotSameRow(editedRow, existingGridRow) && isNullOrEmpty(editedRow.targetFareBrand) && isNullOrEmpty(existingGridRow.targetFareBrand) && !isNullOrEmpty(editedRow.targetCarrier) && !isNullOrEmpty(existingGridRow.targetCarrier) && !isNullOrEmpty(editedRow.targetOrigin) && !isNullOrEmpty(existingGridRow.targetOrigin) && !isNullOrEmpty(editedRow.targetDestination) && !isNullOrEmpty(existingGridRow.targetDestination)) {
        if (!_.isEqual(_.pickBy(editedRow), _.pickBy(existingGridRow)) && editedRow.category === existingGridRow.category && editedRow.targetCarrier === existingGridRow.targetCarrier && editedRow.targetOrigin === existingGridRow.targetOrigin && editedRow.cabin === existingGridRow.cabin && editedRow.targetDestination === existingGridRow.targetDestination && editedRow.targetFareTypeIndicator === existingGridRow.targetFareTypeIndicator && editedRowFormattedTargetFareBasisCode === existingGridRowFormattedTargetFareBasisCode) {
          toastr.error('Multiple Sponsors defined for same target market and fare type indicator');
          return true;
        }
      }
    }
    return false;
  }
  function isNotSameRow(editedRow, existingGridRow) {
    return _.isUndefined(editedRow.originalRowId) || _.isUndefined(existingGridRow.originalRowId) || editedRow.originalRowId !== existingGridRow.originalRowId;
  }
  function duplicateRowsIdentified(existingGridRow, filteredEditedRow, previousEditedRow) {
    return _.isEqual(_.pickBy(existingGridRow), _.pickBy(filteredEditedRow)) || !_.isNil(previousEditedRow) && _.isEqual(_.pickBy(previousEditedRow), _.pickBy(filteredEditedRow));
  }
  function duplicateRowWithMarketAndCategoryIdentified(existingRow, currentRow) {
    if (!isNullOrEmpty(currentRow.sponsorOrigin) && !isNullOrEmpty(existingRow.sponsorOrigin)) {
      return !_.isEqual(_.pickBy(currentRow), _.pickBy(existingRow)) && existingRow.category === currentRow.category && currentRow.sponsorOrigin === existingRow.sponsorOrigin && currentRow.sponsorCarrier === existingRow.sponsorCarrier && currentRow.targetCarrier === existingRow.targetCarrier && currentRow.sponsorDestination === existingRow.sponsorDestination && currentRow.targetOrigin === existingRow.targetOrigin && currentRow.targetDestination === existingRow.targetDestination;
    } else {
      return !_.isEqual(_.pickBy(currentRow), _.pickBy(existingRow)) && existingRow.category === currentRow.category && currentRow.originCountry === existingRow.originCountry && currentRow.destinationCountry === existingRow.destinationCountry;
    }
  }
  function isSponsorAndTargetMarketSame(currentRow) {
    if (!isNullOrEmpty(currentRow.sponsorOrigin) && !isNullOrEmpty(currentRow.sponsorDestination) && !isNullOrEmpty(currentRow.targetOrigin) && !isNullOrEmpty(currentRow.targetDestination)) {
      return currentRow.sponsorCarrier === currentRow.targetCarrier && currentRow.sponsorOrigin === currentRow.targetOrigin && currentRow.sponsorDestination === currentRow.targetDestination;
    }
    return false;
  }
  function checkAllFareBrandsPresent(valid, editedRows, gridData, fareBrandDefinitionPropertiesByCarrier) {
    if (!_.isNil(fareBrandDefinitionPropertiesByCarrier[configurationService.getHostCarrier()])) {
      var allRows = editedRows;
      allRows = allRows.concat(gridData);
      var sponsorMarketGrouping = getRowsGroupedBySponsorMarketCategory(allRows);
      var sponsorMarkets = getHyphenRemovedKeyList(sponsorMarketGrouping);
      _.forEach(sponsorMarkets, function (sponsorMarket) {
        var targetMarketGrouping = getRowsGroupedByTargetMarket(sponsorMarketGrouping[sponsorMarket]);
        var targetMarkets = getHyphenRemovedKeyList(targetMarketGrouping);
        _.forEach(targetMarkets, function (targetMarket) {
          var rowsToCheckForMarketGrouping = targetMarketGrouping[targetMarket];
          valid = valid && allFareBrandsDefined(rowsToCheckForMarketGrouping, fareBrandDefinitionPropertiesByCarrier);
        });
      });
      if (!valid) {
        return false;
      }
      var countryGrouping = getRowsGroupedByCountryCategory(allRows);
      var groupedCountries = getHyphenRemovedKeyList(countryGrouping);
      _.forEach(groupedCountries, function (country) {
        var rowsToCheckForCountryGrouping = countryGrouping[country];
        valid = valid && allFareBrandsDefined(rowsToCheckForCountryGrouping, fareBrandDefinitionPropertiesByCarrier);
      });
      if (!valid) {
        return false;
      }
    }
    return true;
  }
  function allFareBrandsDefined(rowsToCheck, fareBrandDefinitionPropertiesByCarrier) {
    var k, l, row1, row2, count;
    for (k = 0; k < rowsToCheck.length; k++) {
      row1 = rowsToCheck[k];
      if (!isNullOrEmpty(row1.targetFareBrand)) {
        count = 1;
        for (l = 0; l < rowsToCheck.length; l++) {
          row2 = rowsToCheck[l];
          if (!isNullOrEmpty(row2.targetFareBrand)) {
            if (isInvalidBrand(row1, row2)) {
              return false;
            }
            if (isInvalidPercentageIndicator(row1, row2)) {
              return false;
            }
            if (row1.targetFareBrand !== row2.targetFareBrand) {
              count++;
            }
          }
        }
        if (!isNullOrEmpty(row1.sponsorOrigin) && !isNullOrEmpty(row1.sponsorDestination) && !isNullOrEmpty(row1.targetOrigin) && !isNullOrEmpty(row1.targetDestination) && isSponsorAndTargetMarketSame(row1) || !isNullOrEmpty(row1.originCountry) && !isNullOrEmpty(row1.destinationCountry)) {
          if (count === fareBrandDefinitionPropertiesByCarrier[configurationService.getHostCarrier()][0].fareBrands.length - 1) {
            if (row1.sponsorFareBrand === row1.targetFareBrand) {
              if (!isNullOrEmpty(row1.targetOrigin) && !isNullOrEmpty(row1.targetDestination)) {
                toastr.error('All fare brands applicable for TARGET MARKET ' + row1.targetOrigin + '-' + row1.targetDestination + ' not defined for SPONSOR ' + row1.sponsorOrigin + '-' + row1.sponsorDestination);
              } else {
                toastr.error('All fare brands applicable for TARGET not defined for SPONSOR ' + row1.originCountry + '-' + row1.destinationCountry);
              }
              return false;
            } else continue;
          }
        }
        if (count < fareBrandDefinitionPropertiesByCarrier[configurationService.getHostCarrier()][0].fareBrands.length) {
          if (!isNullOrEmpty(row1.targetOrigin) && !isNullOrEmpty(row1.targetDestination)) {
            toastr.error('All fare brands applicable for TARGET MARKET ' + row1.targetOrigin + '-' + row1.targetDestination + ' not defined for SPONSOR ' + row1.sponsorOrigin + '-' + row1.sponsorDestination);
          } else {
            toastr.error('All fare brands applicable for TARGET not defined for SPONSOR ' + row1.originCountry + '-' + row1.destinationCountry);
          }
          return false;
        }
      }
    }
    return true;
  }
  function areFareTypeSameForSameCountry(editedRows, gridData) {
    var valid = true;
    var allRows = editedRows;
    allRows = allRows.concat(gridData);
    var countryGrouping = getRowsGroupedByCountryBrandCategory(allRows);
    var groupedCountries = getHyphenRemovedKeyList(countryGrouping);
    _.forEach(groupedCountries, function (country) {
      if (countryGrouping[country].length > 1) {
        valid = valid && fareTypeSameForCountryGrouping(countryGrouping[country]);
      }
    });
    return valid;
  }
  function fareTypeSameForCountryGrouping(rows) {
    var sponsorFareType = getSponsorFareType(rows[0]);
    var targetFareType = getTargetFareType(rows[0]);
    for (var index = 1; index < rows.length; index++) {
      if (sponsorFareType !== getSponsorFareType(rows[index]) || targetFareType !== getTargetFareType(rows[index])) {
        toastr.error('Fare Type Indicators across fare brands are not same for SPONSOR ' + rows[index].originCountry + ' - ' + rows[index].destinationCountry);
        return false;
      }
    }
    return true;
  }
  function getRowsGroupedByCountryBrandCategory(allrows) {
    return _.groupBy(allrows, function (row) {
      if (row.originCountry && row.destinationCountry && row.sponsorFareBrand && row.category) {
        return [row.originCountry, row.destinationCountry, row.sponsorFareBrand, row.category].join('-');
      }
      return '-';
    });
  }
  function getRowsGroupedByCountryCategory(allrows) {
    return _.groupBy(allrows, function (row) {
      if (row.originCountry && row.destinationCountry && row.category) {
        return [row.originCountry, row.destinationCountry, row.category].join('-');
      }
      return '-';
    });
  }
  function areFareTypeSameForAllTargetMarket(editedRows, gridData) {
    var valid = true;
    var allRows = editedRows;
    allRows = allRows.concat(gridData);
    var sponsorMarketGrouping = getRowsGroupedBySponsorMarketBrandCategory(allRows);
    var sponsorMarkets = getHyphenRemovedKeyList(sponsorMarketGrouping);
    _.forEach(sponsorMarkets, function (sponsorMarket) {
      var targetMarketGrouping = getRowsGroupedByTargetMarket(sponsorMarketGrouping[sponsorMarket]);
      var targetMarkets = getHyphenRemovedKeyList(targetMarketGrouping);
      _.forEach(targetMarkets, function (targetMarket) {
        valid = valid && allEntriesHaveSameFareType(targetMarketGrouping[targetMarket]);
      });
    });
    return valid;
  }
  function getRowsGroupedBySponsorMarketBrandCategory(rows) {
    return _.groupBy(rows, function (row) {
      if (row.sponsorOrigin && row.sponsorDestination && row.sponsorFareBrand && row.category) {
        return [row.sponsorOrigin, row.sponsorDestination, row.sponsorFareBrand, row.category].join('-');
      }
      return '-';
    });
  }
  function getRowsGroupedBySponsorMarketCategory(rows) {
    return _.groupBy(rows, function (row) {
      if (row.sponsorOrigin && row.sponsorDestination && row.category) {
        return [row.sponsorOrigin, row.sponsorDestination, row.category].join('-');
      }
      return '-';
    });
  }
  function getRowsGroupedByTargetMarket(rows) {
    return _.groupBy(rows, function (row) {
      if (row.targetOrigin && row.targetDestination) {
        return [row.targetOrigin, row.targetDestination].join('-');
      }
      return '-';
    });
  }
  function getHyphenRemovedKeyList(groupedRows) {
    var keys = _.keys(groupedRows);
    if (keys.indexOf('-') > -1) {
      keys.splice(keys.indexOf('-'), 1);
    }
    return keys;
  }
  function allEntriesHaveSameFareType(rows) {
    var sponsorFareType = getSponsorFareType(rows[0]);
    var targetFareType = getTargetFareType(rows[0]);
    for (var index = 1; index < rows.length; index++) {
      if (sponsorFareType !== getSponsorFareType(rows[index]) || targetFareType !== getTargetFareType(rows[index])) {
        toastr.error('Fare Type Indicators across fare brands are not same for SPONSOR ' + rows[index].sponsorOrigin + ' - ' + rows[index].sponsorDestination + ' TARGET ' + rows[index].targetOrigin + ' - ' + rows[index].targetDestination);
        return false;
      }
    }
    return true;
  }
  function getSponsorFareType(row) {
    return _.isEmpty(row.sponsorFareTypeIndicator) ? '-' : row.sponsorFareTypeIndicator;
  }
  function getTargetFareType(row) {
    return _.isEmpty(row.targetFareTypeIndicator) ? '-' : row.targetFareTypeIndicator;
  }
  function areFareTypeAndFbcNotDefinedTogether(row) {
    var validationErrorForSponsor = !areSponsorFareTypeAndFbcNotDefinedTogether(row);
    var validationErrorForTarget = !areTargetFareTypeAndFbcNotDefinedTogether(row);
    if (validationErrorForSponsor) {
      toastr.error('Fare Type Indicator and Fbc should not be defined together for SPONSOR ' + getKey(row, 'SPONSOR'));
    }
    if (validationErrorForTarget) {
      toastr.error('Fare Type Indicator and Fbc should not be defined together for TARGET ' + getKey(row, 'TARGET'));
    }
    return !(validationErrorForSponsor || validationErrorForTarget);
  }
  function areSponsorFareTypeAndFbcNotDefinedTogether(row) {
    return _.isEmpty(row.sponsorFareTypeIndicator) || _.isEmpty(row.sponsorFareBasisCode);
  }
  function areTargetFareTypeAndFbcNotDefinedTogether(row) {
    return _.isEmpty(row.targetFareTypeIndicator) || _.isEmpty(row.targetFareBasisCode);
  }
  function getKey(row, type) {
    if (!_.isEmpty(row.originCountry) && !_.isEmpty(row.destinationCountry)) {
      return [row.originCountry, row.destinationCountry].join(' - ');
    }
    if (!_.isEmpty(row.sponsorOrigin) && !_.isEmpty(row.sponsorDestination) && type === 'SPONSOR') {
      return [row.sponsorOrigin, row.sponsorDestination].join(' - ');
    }
    if (!_.isEmpty(row.targetOrigin) && !_.isEmpty(row.targetDestination) && type === 'TARGET') {
      return [row.targetOrigin, row.targetDestination].join(' - ');
    }
    return '';
  }
  function isInvalidBrand(row1, row2) {
    if (row1.sponsorFareBrand !== row2.sponsorFareBrand) {
      if (!isNullOrEmpty(row1.sponsorOrigin)) {
        toastr.error('Only one Sponsor Fare Brand must be defined for the SPONSOR ' + row1.sponsorOrigin + ' - ' + row1.sponsorDestination);
      }
      if (!isNullOrEmpty(row1.originCountry)) {
        toastr.error('Only one Sponsor Fare Brand must be defined for the SPONSOR ' + row1.originCountry + ' - ' + row1.destinationCountry);
      }
      return true;
    }
    return false;
  }
  function isInvalidPercentageIndicator(row1, row2) {
    if (row1.percentageIndicator !== row2.percentageIndicator) {
      if (!isNullOrEmpty(row1.sponsorOrigin)) {
        toastr.error('Value must be either Absolute (A) or Percentage (P) for same SPONSOR ' + row1.sponsorOrigin + ' - ' + row1.sponsorDestination + ' TARGET ' + row1.targetOrigin + ' - ' + row1.targetDestination);
      }
      if (!isNullOrEmpty(row1.originCountry)) {
        toastr.error('Value must be either Absolute (A) or Percentage (P) for same SPONSOR ' + row1.originCountry + ' - ' + row1.destinationCountry);
      }
      return true;
    }
    return false;
  }
  function areRowsValid(editedRows, gridData) {
    var airportRegionByCityCode = _.groupBy(configurationService.getFoAirportRegionMapping(), 'cityCode');
    var valid = true;
    var previousEditedRow;
    if (!_.isNil(configurationService.getFoFareBrandDefinitions())) {
      var fareBrandDefinitionPropertiesByCarrier = _.groupBy(configurationService.getFoFareBrandDefinitions(), 'carrier');
      if (!_.isNil(fareBrandDefinitionPropertiesByCarrier[configurationService.getHostCarrier()])) {
        var fareBrandMap = _.groupBy(fareBrandDefinitionPropertiesByCarrier[configurationService.getHostCarrier()][0].fareBrands, 'fareBrand');
      }
    }
    for (var i = 0, editedRowsLength = editedRows.length; i < editedRowsLength; i++) {
      var editedRow = editedRows[i];
      editedRow.sponsorCarrier = editedRow.foSponsorCarrier;
      editedRow.sponsorOrigin = editedRow.foSponsorOrigin;
      editedRow.sponsorDestination = editedRow.foSponsorDestination;
      editedRow.cabin = editedRow.linkedCabin;
      editedRow.targetCarrier = editedRow.foTargetCarrier;
      editedRow.targetOrigin = editedRow.foTargetOrigin;
      editedRow.targetDestination = editedRow.foTargetDestination;
      editedRow.originCountry = editedRow.foOriginCountry;
      editedRow.destinationCountry = editedRow.foDestCountry;
      valid = validateField(editedRow.value, 'value', valid);
      valid = validateField(editedRow.percentageIndicator, '% Indicator', valid);
      valid = sponsorAndTargetMarketsBelongToSamePos(airportRegionByCityCode, editedRow, valid);
      if (!isNullOrEmpty(editedRow.targetFareBrand)) {
        valid = isValidFareBrandAndValue(fareBrandMap, editedRow, gridData, valid) && isValidFareBrandAndValue(fareBrandMap, editedRow, editedRows, valid);
      }
      valid = validateFields(editedRow, valid);
      if (!isNullOrEmpty(editedRow.sponsorOrigin) && !isNullOrEmpty(editedRow.sponsorDestination) && !isNullOrEmpty(editedRow.targetOrigin) && !isNullOrEmpty(editedRow.targetDestination) && isSponsorAndTargetMarketSame(editedRow)) {
        if (!isNullOrEmpty(editedRow.sponsorFareBrand) && !isNullOrEmpty(editedRow.targetFareBrand) && editedRow.sponsorFareBrand === editedRow.targetFareBrand) {
          toastr.error(' For same Sponsor and Target market, sponsor fare brand must not be same as target fare brand.');
          valid = false;
        }
      }
      if (!isNullOrEmpty(editedRow.originCountry) && !isNullOrEmpty(editedRow.destinationCountry)) {
        if (!isNullOrEmpty(editedRow.sponsorFareBrand) && !isNullOrEmpty(editedRow.targetFareBrand) && editedRow.sponsorFareBrand === editedRow.targetFareBrand) {
          toastr.error(' For ORIGIN-DESTINATION country, sponsor fare brand must not be same as target fare brand.');
          valid = false;
        }
      }
      if (valid) {
        var filteredEditedRow = _.omit(editedRow, ['isNewlyAdded', 'isRowEditable', '_old', 'originalRowId']);
        var isSameRecordFound = 0;
        for (var j = 0, gridDataLength = gridData.length; j < gridDataLength; j++) {
          var existingGridRow = gridData[j];
          if (duplicateRowsIdentified(existingGridRow, filteredEditedRow, previousEditedRow)) {
            valid = false;
          } else if (hasSameTargetFbcPattern(existingGridRow, filteredEditedRow)) {
            if (++isSameRecordFound > 1) {
              valid = false;
            }
          }
          if (!valid) {
            toastr.error('duplicate rows identified');
            break;
          }
          if (valid && isTargetDataMatch(editedRow, existingGridRow) || !_.isNil(previousEditedRow) && isTargetDataMatch(editedRow, previousEditedRow)) {
            valid = false;
            break;
          }
        }
        previousEditedRow = filteredEditedRow;
      }
      if (!valid) {
        return false;
      }
    }
    valid = valid && checkAllFareBrandsPresent(valid, editedRows, gridData, fareBrandDefinitionPropertiesByCarrier) && areFareTypeSameForAllTargetMarket(editedRows, gridData) && areFareTypeSameForSameCountry(editedRows, gridData);
    return valid;
  }
  function save(editedRows) {
    var rowsForDeletion = [];
    _.forEach(editedRows, function (editedRow) {
      if (_.has(editedRow, '_old') && !_.has(editedRow, 'isNewlyAdded')) {
        rowsForDeletion.push(buildPayLoadForRemovalWhileSaving(editedRow));
      }
    });
    if (!_.isEmpty(rowsForDeletion)) {
      $q.all(deleteFromServer(rowsForDeletion));
    }
    var payloads = buildSavePayloads(editedRows);
    var promises = [];
    if (payloads && payloads.length) {
      promises.push(saveToServer(payloads));
    }
    return $q.all(promises);
  }
  function getStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value;
  }
  function buildPayLoadForRemovalWhileSaving(row) {
    return {
      category: _.has(row._old, 'category') ? getStringValue(row._old.category) : getStringValue(row.category),
      cabin: _.has(row._old, 'linkedCabin') ? getStringValue(row._old.linkedCabin) : getStringValue(row.linkedCabin),
      originCountry: _.has(row._old, 'foOriginCountry') ? getStringValue(row._old.foOriginCountry) : getStringValue(row.foOriginCountry),
      destinationCountry: _.has(row._old, 'foDestCountry') ? getStringValue(row._old.foDestCountry) : getStringValue(row.foDestCountry),
      sponsorCarrier: _.has(row._old, 'foSponsorCarrier') ? getStringValue(row._old.foSponsorCarrier) : getStringValue(row.foSponsorCarrier),
      sponsorOrigin: _.has(row._old, 'foSponsorOrigin') ? getStringValue(row._old.foSponsorOrigin) : getStringValue(row.foSponsorOrigin),
      sponsorDestination: _.has(row._old, 'foSponsorDestination') ? getStringValue(row._old.foSponsorDestination) : getStringValue(row.foSponsorDestination),
      sponsorFareTypeIndicator: _.has(row._old, 'sponsorFareTypeIndicator') ? getStringValue(row._old.sponsorFareTypeIndicator) : getStringValue(row.sponsorFareTypeIndicator),
      sponsorFareBrand: _.has(row._old, 'sponsorFareBrand') ? getStringValue(row._old.sponsorFareBrand) : getStringValue(row.sponsorFareBrand),
      sponsorFareBasisCode: _.has(row._old, 'sponsorFareBasisCode') ? getStringValue(row._old.sponsorFareBasisCode) : getStringValue(row.sponsorFareBasisCode),
      targetCarrier: _.has(row._old, 'foTargetCarrier') ? getStringValue(row._old.foTargetCarrier) : getStringValue(row.foTargetCarrier),
      targetOrigin: _.has(row._old, 'foTargetOrigin') ? getStringValue(row._old.foTargetOrigin) : getStringValue(row.foTargetOrigin),
      targetDestination: _.has(row._old, 'foTargetDestination') ? getStringValue(row._old.foTargetDestination) : getStringValue(row.foTargetDestination),
      targetFareTypeIndicator: _.has(row._old, 'targetFareTypeIndicator') ? getStringValue(row._old.targetFareTypeIndicator) : getStringValue(row.targetFareTypeIndicator),
      targetFareBrand: _.has(row._old, 'targetFareBrand') ? getStringValue(row._old.targetFareBrand) : getStringValue(row.targetFareBrand),
      targetFareBasisCode: _.has(row._old, 'targetFareBasisCode') ? getStringValue(row._old.targetFareBasisCode) : getStringValue(row.targetFareBasisCode),
      value: _.has(row._old, 'value') ? row._old.value : row.value,
      percentageIndicator: _.has(row._old, 'percentageIndicator') ? row._old.percentageIndicator === 'P' : row.percentageIndicator === 'P'
    };
  }
  function buildRemovePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  function buildPayload(row) {
    return {
      category: row.category,
      cabin: _.isNil(row.linkedCabin) || row.linkedCabin === '' ? null : row.linkedCabin,
      originCountry: _.isNil(row.foOriginCountry) || row.foOriginCountry === '' ? null : row.foOriginCountry,
      destinationCountry: _.isNil(row.foDestCountry) || row.foDestCountry === '' ? null : row.foDestCountry,
      sponsorCarrier: _.isNil(row.foSponsorCarrier) || row.foSponsorCarrier === '' ? null : row.foSponsorCarrier,
      sponsorOrigin: _.isNil(row.foSponsorOrigin) || row.foSponsorOrigin === '' ? null : row.foSponsorOrigin,
      sponsorDestination: _.isNil(row.foSponsorDestination) || row.foSponsorDestination === '' ? null : row.foSponsorDestination,
      sponsorFareTypeIndicator: _.isNil(row.sponsorFareTypeIndicator) || row.sponsorFareTypeIndicator === '' ? null : row.sponsorFareTypeIndicator,
      sponsorFareBrand: _.isNil(row.sponsorFareBrand) || row.sponsorFareBrand === '' ? null : row.sponsorFareBrand,
      sponsorFareBasisCode: _.isNil(row.sponsorFareBasisCode) || row.sponsorFareBasisCode === '' ? null : row.sponsorFareBasisCode,
      targetCarrier: _.isNil(row.foTargetCarrier) || row.foTargetCarrier === '' ? null : row.foTargetCarrier,
      targetOrigin: _.isNil(row.foTargetOrigin) || row.foTargetOrigin === '' ? null : row.foTargetOrigin,
      targetDestination: _.isNil(row.foTargetDestination) || row.foTargetDestination === '' ? null : row.foTargetDestination,
      targetFareTypeIndicator: _.isNil(row.targetFareTypeIndicator) || row.targetFareTypeIndicator === '' ? null : row.targetFareTypeIndicator,
      targetFareBrand: _.isNil(row.targetFareBrand) || row.targetFareBrand === '' ? null : row.targetFareBrand,
      targetFareBasisCode: _.isNil(row.targetFareBasisCode) || row.targetFareBasisCode === '' ? null : row.targetFareBasisCode,
      value: row.value,
      percentageIndicator: row.percentageIndicator === 'P'
    };
  }
  function buildSavePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  return {
    validate: validate,
    exportToCsv: exportToCsv,
    save: save,
    remove: remove
  };
};
ConfigurationLinkedFbcService.$inject = ['FileSaveService', 'MomentService', 'ConfigurationService', 'Restangular', '$q', '$http'];
module.exports = ConfigurationLinkedFbcService;